import { render, staticRenderFns } from "./AddLossModal.vue?vue&type=template&id=36f818ef&"
import script from "./AddLossModal.vue?vue&type=script&lang=ts&"
export * from "./AddLossModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddLossModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f818ef')) {
      api.createRecord('36f818ef', component.options)
    } else {
      api.reload('36f818ef', component.options)
    }
    module.hot.accept("./AddLossModal.vue?vue&type=template&id=36f818ef&", function () {
      api.rerender('36f818ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddLossModal/AddLossModal.vue"
export default component.exports